var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclamationCircle = function SvgExclamationCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.002 19.45a8.44 8.44 0 0 1-8.451-8.452A8.44 8.44 0 0 1 11 2.547a8.44 8.44 0 0 1 8.452 8.451 8.44 8.44 0 0 1-8.451 8.451Z",
    stroke: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.102,
    y: 13.199,
    width: 2.2,
    height: 7.7,
    rx: 1,
    transform: "rotate(-180 12.102 13.2)",
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.102,
    y: 16.5,
    width: 2.2,
    height: 2.2,
    rx: 1,
    transform: "rotate(-180 12.102 16.5)",
    fill: "currentColor"
  })));
};
export default SvgExclamationCircle;